export const SystemPaleBgPaletteDark: any = {
    0: '#FFFFFF',
    1: '#C2C4C5',
    2: '#FFADA8',
    3: '#FADF8D',
    4: '#AAE4B9',
    5: '#2E374A', //'#DBEAFF',
}